var G=Object.create;var S=Object.defineProperty,K=Object.defineProperties,Q=Object.getOwnPropertyDescriptor,X=Object.getOwnPropertyDescriptors,oo=Object.getOwnPropertyNames,N=Object.getOwnPropertySymbols,eo=Object.getPrototypeOf,H=Object.prototype.hasOwnProperty,to=Object.prototype.propertyIsEnumerable;var I=(t,e,o)=>e in t?S(t,e,{enumerable:!0,configurable:!0,writable:!0,value:o}):t[e]=o,m=(t,e)=>{for(var o in e||(e={}))H.call(e,o)&&I(t,o,e[o]);if(N)for(var o of N(e))to.call(e,o)&&I(t,o,e[o]);return t},g=(t,e)=>K(t,X(e));var ro=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports);var no=(t,e,o,i)=>{if(e&&typeof e=="object"||typeof e=="function")for(let r of oo(e))!H.call(t,r)&&r!==o&&S(t,r,{get:()=>e[r],enumerable:!(i=Q(e,r))||i.enumerable});return t};var io=(t,e,o)=>(o=t!=null?G(eo(t)):{},no(e||!t||!t.__esModule?S(o,"default",{value:t,enumerable:!0}):o,t));var A=ro((po,v)=>{"use strict";(function(){"use strict";var t={}.hasOwnProperty;function e(){for(var r="",a=0;a<arguments.length;a++){var s=arguments[a];s&&(r=i(r,o(s)))}return r}function o(r){if(typeof r=="string"||typeof r=="number")return r;if(typeof r!="object")return"";if(Array.isArray(r))return e.apply(null,r);if(r.toString!==Object.prototype.toString&&!r.toString.toString().includes("[native code]"))return r.toString();var a="";for(var s in r)t.call(r,s)&&r[s]&&(a=i(a,s));return a}function i(r,a){return a?r?r+" "+a:r+a:r}typeof v!="undefined"&&v.exports?(e.default=e,v.exports=e):typeof define=="function"&&typeof define.amd=="object"&&define.amd?define("classnames",[],function(){return e}):window.classNames=e})()});import p from"react";var O=io(A());import n,{useMemo as lo,useRef as so,useState as h}from"react";var z="6b2765a69b8a36b63740fce9281c46ee636e9ef15acf9494799bf41f1551db1f",ao=`._container_18f8u_1 {
	--brand-color: #744ed4;
	--brand-color-dark: #5629c6;
	--color-text-primary: #111111;
	--color-text-primary-inverted: #fff;
	--color-text-link: var(--brand-color);
	--size-large: 24px;
	--size-medium: 16px;
	--size-small: 12px;
	--size-xSmall: 8px;

	--color-white: #fff;
	--color-gray-100: hsla(0, 0%, 93.7%, 0.49019607843137253);
	--color-gray-200: #f2f2f2;
	--color-gray-300: #eaeaea;
	--color-gray-400: #bdbdbd;
	--color-gray-500: #828282;
	--color-gray-600: #7e7e7e;
	--color-gray-700: #8a8f98;
	--color-gray-800: #2d2f36;

	--font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI',
		Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
		'Segoe UI Emoji', 'Segoe UI Symbol';

	background: hsl(0deg 0% 0% / 75%);
	font-family: var(--font-family);
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 999999;
	backdrop-filter: blur(1px);
	display: flex;
	justify-content: center;
	align-items: center;
}

@media only screen and (max-width: 420px) {
	._card_18f8u_41 {
		max-width: 100vw !important;
		height: 100%;
		border-radius: 0;
	}

	._cardContents_18f8u_47 {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	._form_18f8u_53 {
		height: 100%;
	}

	._textareaLabel_18f8u_57 {
		flex: 1;
	}

	._form_18f8u_53 textarea {
		height: 100%;
	}

	._ad_18f8u_65 {
		display: none;
	}
}

._card_18f8u_41 {
	border-radius: var(--size-xSmall);
	padding: 20px;
	width: 420px;
	max-width: calc(100vw - 1rem);
	background: white;
}

._title_18f8u_78 {
	font-size: 20px;
	color: var(--color-text-primary);
}

._subtitle_18f8u_83 {
	font-size: 13px;
	margin-top: var(--size-medium) !important;
	font-weight: 400;
	color: #8c8b92;
}

._form_18f8u_53 {
	padding-top: var(--size-large);
	display: flex;
	flex-direction: column;
	gap: var(--size-small);
	width: 100%;
}

._form_18f8u_53 label {
	display: flex;
	flex-direction: column;
	font-size: 11px !important;
	font-weight: 500;
	color: var(--color-gray-500);
}

._form_18f8u_53 input {
	height: 28px;
}

._form_18f8u_53 textarea {
	font-family: var(--font-family);
	min-height: 80px;
}

._form_18f8u_53 input,
._form_18f8u_53 textarea {
	background-color: var(--color-white);
	border: 1px solid #dcdbdd;
	border-radius: 6px;
	color: var(--color-gray-500);

	font-size: 13px;
	margin: 8px 0;
	outline: none;
	padding: 4px 6px;
	width: calc(100%);
}

._form_18f8u_53 button {
	align-items: center;
	display: flex;
	justify-content: center;
	height: auto;
	color: var(--color-text-primary-inverted);
	background-color: var(--brand-color);
	text-shadow: none;
	box-shadow: none;
	padding: 4px 6px;
	font-size: 14px;
	border-radius: 6px;
	border: 0;
	cursor: pointer;
}

._form_18f8u_53 button:hover {
	background-color: var(--brand-color-dark);
}

._form_18f8u_53 button[disabled] {
	opacity: 0.5;
	pointer-events: none;
}

._form_18f8u_53 ._closeButton_18f8u_154 {
	background-color: transparent;
	color: #6f6e77 !important;
	font-size: 13px;
	font-family: var(--font-family);
	border: 1px solid var(--color-white);
}

._form_18f8u_53 ._closeButton_18f8u_154:hover {
	background-color: var(--color-gray-100);
	border-color: var(--color-gray-300);
}

._confirmationButton_18f8u_167 {
	float: right;
	margin-top: 3rem;
}

._formFooter_18f8u_172 {
	display: flex;
	flex-direction: row-reverse;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
}

._formActionsContainer_18f8u_180 {
	display: flex;
	flex-direction: row-reverse;
	gap: 6px;
}

._ad_18f8u_65:hover {
	background-color: var(--color-gray-100);
}

._logoContainer_18f8u_190 {
	display: flex;
	align-items: center;
	gap: 6px;

	border: 1px solid var(--color-gray-300);
	border-radius: 6px;
	color: var(--color-gray-500);
	font-size: 13px;
	padding: 4px 8px;
}

._logo_18f8u_190 {
	height: 16px;
}

._buggyButton_18f8u_206 {
	align-items: center;
	background: #5629c6;
	border-radius: 8px;
	border: 1px solid #bdbdbd;
	box-shadow: none;
	color: #fff;
	cursor: pointer;
	display: flex;
	font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI',
		Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
		'Segoe UI Emoji', 'Segoe UI Symbol';
	font-size: 14px;
	height: auto;
	justify-content: center;
	min-height: 40px;
	padding: 4px 16px;
	text-shadow: none;
}
`;(function(){if(typeof document!="undefined"&&!document.getElementById(z)){var t=document.createElement("style");t.id=z,t.textContent=ao,document.head.appendChild(t)}})();var l={container:"_container_18f8u_1",card:"_card_18f8u_41",cardContents:"_cardContents_18f8u_47",form:"_form_18f8u_53",textareaLabel:"_textareaLabel_18f8u_57",ad:"_ad_18f8u_65",title:"_title_18f8u_78",subtitle:"_subtitle_18f8u_83",closeButton:"_closeButton_18f8u_154",confirmationButton:"_confirmationButton_18f8u_167",formFooter:"_formFooter_18f8u_172",formActionsContainer:"_formActionsContainer_18f8u_180",logoContainer:"_logoContainer_18f8u_190",logo:"_logo_18f8u_190",buggyButton:"_buggyButton_18f8u_206"};function k({labelClose:t="Cancel",labelComments:e="Message",labelName:o="Name",labelEmail:i="Email",labelSubmit:r="Submit",subtitle2:a="If you\u2019d like to help, tell us what happened below.",subtitle:s="Our team has been notified.",successMessage:d="Your feedback has been sent. Thank you!",successSubtitle:f="Thank you for sending us feedback. If you have any other concerns/questions, reach out to this application's support email.",title:_="It looks like we\u2019re having issues.",placeholderComments:j="I typed in a name then clicked the button",user:u,onCloseHandler:E,onSubmitHandler:C,hideHighlightBranding:T=!1,error:w}){let[b,U]=h((u==null?void 0:u.name)||""),[y,L]=h((u==null?void 0:u.email)||""),[x,P]=h(""),[V,D]=h(!1),[Z,W]=h(!1),Y=so(new Date().toISOString()),$=lo(()=>{let c=!!y.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);return!!b&&c&&!!x},[b,y,x]);n.useEffect(()=>{var c;(c=window==null?void 0:window.H)!=null&&c.consumeError&&w&&window.H.consumeError(w)},[w]);let q=c=>{var B;c.preventDefault(),D(!0),(B=window==null?void 0:window.H)!=null&&B.addSessionFeedback?window.H.addSessionFeedback({verbatim:x,userName:b,userEmail:y,timestampOverride:Y.current}):console.warn("Highlight is not initialized. Make sure highlight.run is installed and running."),new Promise(J=>window.setTimeout(J,300)).then(()=>{D(!1),W(!0),C&&C()})};return n.createElement(n.Fragment,null,n.createElement("style",{dangerouslySetInnerHTML:{__html:`
					@font-face {
						font-display: swap;
						font-family: 'Inter';
						font-style: normal;
						font-weight: normal;
						src: local('Inter Regular'), local('InterRegular'),
							url('https://app.highlight.io/font/Inter-Regular.woff2')
								format('woff2');
					}
					@font-face {
						font-display: swap;
						font-family: 'Inter';
						font-style: normal;
						font-weight: 500;
						src: local('Inter Medium'), local('InterMedium'),
							url('https://app.highlight.io/font/Inter-Medium.woff2')
								format('woff2');
					}

					::placeholder {
						color: var(--color-gray-300);
					}
			`}}),n.createElement("main",{className:l.container},n.createElement("div",{className:l.card},Z?n.createElement("div",{className:l.cardContents},n.createElement("h1",{className:l.title},d),n.createElement("h4",{className:l.subtitle},f),n.createElement("div",null,n.createElement("button",{className:(0,O.default)(l.button,l.confirmationButton),onClick:E},"Close"))):n.createElement("div",{className:l.cardContents},n.createElement("div",null,n.createElement("h1",{className:l.title},_),n.createElement("h2",{className:l.subtitle},s," ",a)),n.createElement("form",{className:l.form,onSubmit:q},n.createElement("label",null,o,n.createElement("input",{type:"text",value:b,name:"name",autoFocus:!0,onChange:c=>{U(c.target.value)},placeholder:"Tom Jerry"})),n.createElement("label",null,i,n.createElement("input",{type:"email",value:y,name:"email",onChange:c=>{L(c.target.value)},placeholder:"mail@mail.com"})),n.createElement("label",{className:l.textareaLabel},e,n.createElement("textarea",{value:x,placeholder:j,name:"verbatim",rows:3,onChange:c=>{P(c.target.value)}})),n.createElement("div",{className:l.formFooter},n.createElement("div",{className:l.formActionsContainer},n.createElement("button",{type:"submit",disabled:!$||V},r),n.createElement("button",{className:l.closeButton,onClick:E,type:"button"},t)),!T&&n.createElement("div",{className:l.ad},n.createElement("a",{href:"https://highlight.io",target:"_blank"},n.createElement("div",{className:l.logoContainer},n.createElement("img",{src:"https://www.highlight.io/images/logo-on-dark.png",alt:"Highlight",className:l.logo}),n.createElement("span",null,"Powered by highlight.io"))))))))))}var R={componentStack:null,error:null,showingDialog:!1},M=class extends p.Component{constructor(){super(...arguments);this.state=R;this.resetErrorBoundary=()=>{let{onReset:o}=this.props,{error:i,componentStack:r}=this.state;o&&o(i,r),this.setState(R)};this.hideDialog=()=>{this.setState(g(m({},this.state),{showingDialog:!1})),(this.props.onAfterReportDialogCancelHandler||(()=>{window.location.href=window.location.origin}))()};this.onReportDialogSubmitHandler=()=>{this.props.onAfterReportDialogSubmitHandler&&this.props.onAfterReportDialogSubmitHandler()}}componentDidCatch(o,i){var d,f,_;let{beforeCapture:r,onError:a,showDialog:s}=this.props;r&&r(o,(d=i.componentStack)!=null?d:null),co(o,i),a&&a(o,(f=i.componentStack)!=null?f:""),s!==!1&&this.setState(g(m({},this.state),{showingDialog:!0})),this.setState({error:o,componentStack:(_=i.componentStack)!=null?_:null})}componentDidMount(){let{onMount:o}=this.props;o&&o()}componentWillUnmount(){let{error:o,componentStack:i}=this.state,{onUnmount:r}=this.props;r&&r(o,i)}render(){let{fallback:o,children:i,customDialog:r}=this.props,{error:a,componentStack:s,showingDialog:d}=this.state;if(a){let f;return typeof o=="function"?f=o({error:a,componentStack:s,resetError:this.resetErrorBoundary}):f=o,p.isValidElement(f)?p.createElement(p.Fragment,null,d&&p.createElement(k,g(m({},this.props.dialogOptions),{onCloseHandler:this.hideDialog,onSubmitHandler:this.onReportDialogSubmitHandler})),f):(o&&console.warn("fallback did not produce a valid ReactElement"),d&&r?r:d&&p.createElement(k,g(m({},this.props.dialogOptions),{onCloseHandler:this.hideDialog,onSubmitHandler:this.onReportDialogSubmitHandler})))}return typeof i=="function"?i():i}};function co(t,e){var i;let o=fo((i=e.componentStack)!=null?i:"");window.H?(console.error("Highlight ErrorBoundary caught an exception while rendering React component",{error:t}),window.H.consume(t,{payload:{component:o},source:o,type:"React.ErrorBoundary"})):console.warn("You need to install highlight.run.")}function fo(t){let e=t.split(`
`);if(e.length<1)return;let i=e[1].trim().split(" ");if(i.length===4)return`<${i[1]}>`}import F from"react";var Eo=({children:t})=>{let[e,o]=F.useState(!1);if(e)throw new Error("something bad happened - this is a sample test error");return F.createElement("button",{type:"button",className:"buggyButton",onClick:()=>o(!0)},t!=null?t:"Throw an Error")};export{M as ErrorBoundary,k as ReportDialog,Eo as SampleBuggyButton};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/
